// extracted by mini-css-extract-plugin
module.exports = {"button":"getStartedButton_button__3b1-v"};